import React, { Component } from 'react';
import { MsalProvider, withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import BreadCrumbComponent from '../bread-crumb/BreadCrumbComponent';
import { Button } from 'primereact/button';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { CustomAzureAlertService } from './CustomAzAlertService';
import { AdminService } from '../admin/AdminService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import AlertMessage from "../alertmessage/AlertMessage";
import { MessageSeverity, FilterMatchMode, FilterOperator } from 'primereact/api';
import { MultiSelect } from 'primereact/multiselect';
import Spinner from '../Spinner'

//import '../AdminComponent.css';

class CustomAzAlertActionComponent extends Component {
    constructor() {
        super();
        this.state = {
            pageErrorMessage: '',
            pageSuccessMessage: '',
            pageUnauthorizedMessage: '',
            hasReadRights: true,
            showpagination: false,
            customAzureAlerts: [],
            customAzureAlert: {},
            confirmDeleteVisible: false,
            hideSpinner: false,
            adminRoles: [],
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'Priority': { value: null, matchMode: FilterMatchMode.IN },
                'Status': { value: null, matchMode: FilterMatchMode.IN }
            },
            globalFilterValue: ''
        }
        this.priorityIdList = [1, 2, 3, 4];
        this.statusOptions = ['ACTIVE', 'INACTIVE'];
        this.customAzureAlertService = new CustomAzureAlertService();
        this.adminService = new AdminService();
    }

    componentDidMount() {
        this._isMounted = true;
        this.getAdminRoles()
    }

    getAdminRoles = () => {
        this.adminService.getAdminRoles(this.props.msalContext).then(
            (d) => {
                this.setState({ adminRoles: d, pageErrorMessage: null });
                this.getCustomAzureAlertRule()
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getRoleId = () => {
        var adminRoles = this.state.adminRoles;
        if (adminRoles && adminRoles.length > 0) {
            switch (true) {
                case adminRoles.includes('SuperAdmin'):
                case adminRoles.includes('Admin'):
                    return 1;
                default:
                    return 0;
            }
        }
        return 0;
    }

    getCustomAzureAlertRule = () => {
        this.setState({ hideSpinner: false, pageErrorMessage: null, pageSuccessMessage: null })
        if (this.getRoleId() === 1) {
            this.customAzureAlertService.getCustomAzureAlertRule(this.props.msalContext).then(
                (d) => {
                    if (d.status === 403) {
                        this.setState({ pageErrorMessage: 'You do not have permission to view this page.', pageSuccessMessage: null, hideSpinner: true });
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                customAzureAlerts: d.body.map((item) => {
                                    let updatedItem = {}
                                    updatedItem = { ...item, Status: item.Status ? 'ACTIVE' : 'INACTIVE' }
                                    return updatedItem;
                                }), hideSpinner: true, pageErrorMessage: null, pageSuccessMessage: null
                            });
                            if (this.state.customAzureAlerts.length > 10) {
                                this.setState({ showpagination: true })
                            }
                        }
                    }
                }
            ).catch(e => {
                console.log(e)
            });
        }
        else {
            this.setState({ hideSpinner: true, pageUnauthorizedMessage: 'You do not have permission to view this page. Please contact Corp-HIE_DevOps_Team@northwell.edu.' })
        }
    }

    deleteRecord = () => {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' })
        this.customAzureAlertService.deleteCustomAzureAlertRule(this.state.customAzureAlert.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to perform this operation.', hideSpinner: true });
                } else if (d.status === 200) {
                    this.getCustomAzureAlertRule();
                    this.setState({ confirmDeleteVisible: false, hideSpinner: true, pageSuccessMessage: 'Rule deleted successfully !!!' });
                }
                else {
                    this.setState({ pageErrorMessage: 'Something went wrong !!!', hideSpinner: true });
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    globalSearchFilter = (filtersKey) => {
        return (
            <div>
                <div className="flex justify-content-between" >
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearDataTableFilters} />
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"></i>
                        <InputText type="search" value={this.state[`${filtersKey}`]['global'].value || ''} onChange={(e) => this.onGlobalFilterChange(e, filtersKey)} placeholder="Global Search" size="100" />
                    </span>
                    <Button tooltip='Refresh' tooltipOptions={{ position: 'top' }} onClick={this.getCustomAzureAlertRule} icon="pi pi-refresh" />
                </div>
            </div>
        )
    }

    onGlobalFilterChange = (event, filtersKey) => {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null })

        const value = event.target.value;
        let filters = { ...this.state[filtersKey] };
        filters['global'].value = value;

        this.setState({ [`${filtersKey}`]: filters });
    }

    clearDataTableFilters = () => {
        this.setState({
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'Priority': { value: null, matchMode: FilterMatchMode.IN },
                'Status': { value: null, matchMode: FilterMatchMode.IN },
            },
            pageErrorMessage: null, pageSuccessMessage: null
        });
        sessionStorage.clear();
    }


    priorityFilterTemplate = (options) => {
        return <MultiSelect value={options.value} options={this.priorityIdList}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Priority" className="multiselect-custom"
        />;
    }

    booleanChecker = (rowData) => {
        return <span className={`alertprocessing-status-badge status-${rowData.Status.toLowerCase()}`}>{rowData.Status}</span>;
    };

    statusOptionFilterTemplate = (options) => {
        return <MultiSelect value={options.value} options={this.statusOptions}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Status" className="multiselect-custom"
        />;
    }

    editCustomAzAlertRule = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-primary p-mr-2" tooltip="Edit" tooltipOptions={{ position: 'top' }} onClick={() => window.open('/admin/custom/azure/alert/rule/edit/' + rowData.Id, "_blank")} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Delete" tooltipOptions={{ position: 'top' }} onClick={e => this.setState({ confirmDeleteVisible: true, customAzureAlert: { ...rowData } })} />
            </React.Fragment>
        );
    }

    confirmDeleteFooter = (
        <div>
            <Button label='Ok' onClick={() => this.deleteRecord()} />
            <Button label='Cancel' onClick={e => this.setState({ confirmDeleteVisible: false, pageErrorMessage: '', pageSuccessMessage: '' })}
                className='p-button-secondary' />
        </div>
    );

    showAlertMessage(severity, alertMsg) {
        this.alertMsg.showAlert(severity, alertMsg);
    }

    render() {
        return (
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <div className="actiongroupContainer">
                    <BreadCrumbComponent {...this.props} />
                    <AlertMessage ref={instance => { this.alertMsg = instance }} />

                    {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                    {this.state.pageSuccessMessage ? this.showAlertMessage(MessageSeverity.SUCCESS, this.state.pageSuccessMessage) : <></>}

                    <div hidden={this.state.hideSpinner}>
                        <Spinner />
                    </div>

                    {this.getRoleId() === 0 ? <div className='text-danger text-center'>{this.state.pageUnauthorizedMessage}</div> :
                        <div>
                            <div className='flex justify-content-between' style={{ marginBottom: '10px' }}>
                                <div className="page-header-title">AZURE ALERT RULE</div>
                                <Button label='' icon='pi pi-plus' tooltip='Create azure alert rule' tooltipOptions={{ position: 'left' }} disabled={this.getRoleId() === 1 ? false : true}
                                    onClick={() => window.open('/admin/custom/azure/alert/rule/create', '_blank')} />
                            </div>

                            <DataTable
                                value={this.state.customAzureAlerts}
                                selectionMode="single"
                                paginator={this.state.showpagination}
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                responsiveLayout="scroll"
                                filters={this.state.filters}
                                header={this.globalSearchFilter('filters')}
                                emptyMessage="No Records found."
                                showGridlines={true}
                                onFilter={(e) => this.setState({ filters: e.filters })}
                                stateStorage="session" stateKey="dt-custom-azurealert-session"
                            >
                                <Column field="ResourceType" header="Resource Type" style={{ textAlign: 'left' }} />
                                <Column field="Name" header="Alert Name" style={{ textAlign: 'left' }} />
                                <Column field="Priority" header="Priority" filter filterElement={this.priorityFilterTemplate} showFilterMatchModes={false} filterPlaceholder='Priority' style={{ textAlign: 'left', width: '150px' }} sortable />
                                <Column field="ResourceName" header="Resource Name" style={{ textAlign: 'left' }} />
                                <Column field="Status" header="Status" filter filterElement={this.statusOptionFilterTemplate} showFilterMatchModes={false} filterPlaceholder='Priority' style={{ textAlign: 'left', width: '150px' }} body={this.booleanChecker} />
                                {/* <Column field="TriggerEmail" header="Trigger Email" style={{ textAlign: 'left', width: '150px' }} body={this.booleanChecker} /> */}
                                <Column field="edit" header="Action" body={this.editCustomAzAlertRule} style={{ whiteSpace: 'nowrap', width: '150px', textAlign: 'center' }} />
                            </DataTable>
                        </div>
                    }
                    <Dialog header='Delete threshold rule' footer={this.confirmDeleteFooter}
                        visible={this.state.confirmDeleteVisible} width='400px' modal={true}
                        onHide={e => this.setState({ confirmDeleteVisible: false })} maximizable={false}>
                        <div>
                            Are you sure you want to delete the rule <b>{this.state.customAzureAlert.Name}</b>?
                        </div>
                    </Dialog>
                </div>
            </MsalAuthenticationTemplate>
        )
    }
}

const WrappedCustomAzAlertActionComponent = withMsal(CustomAzAlertActionComponent);
export default withAITracking(reactPlugin, WrappedCustomAzAlertActionComponent);